var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui container container--list"},[_vm._l((_vm.jobs),function(job){return [_c('SyncListItem',{key:job.id,attrs:{"job":job,"responses":_vm.responses,"images":_vm.images}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }